import React from 'react';
import { tours } from '../data';
import Tours from './Tours';
import { Title } from '../components';

const featuredTours = tours.slice(0, 6);
const Featured = () => {
  return (
    <>
      <section className="py-20 bg-green-100" id="featured">
        <Title title="featured tours" />
        <div className="section-center  rounded-3xl ">
          <Tours tours={featuredTours} color="green" />
        </div>
      </section>
    </>
  );
};

export default Featured;
